import React, { useEffect } from 'react';
import { getCorrectFileUrl } from '../utils/fileUtils';

const ImagePreviewDialog = ({ isOpen, onClose, imageUrl }) => {
  useEffect(() => {
    // Close dialog when escape key is pressed
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener('keydown', handleEscape);
    }

    return () => {
      window.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleClick = (e) => {
    // Close dialog when clicking outside the image (on backdrop)
    if (e.target.classList.contains('backdrop')) {
      onClose();
    }
  };

  // Always use the correct URL with 'main' path segment
  const correctedImageUrl = getCorrectFileUrl(imageUrl);

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-80 backdrop-blur-sm z-50 flex items-center justify-center backdrop"
      onClick={handleClick}
    >
      <div className="relative max-w-4xl mx-auto p-4">
        <button 
          className="absolute top-2 right-2 text-white bg-gray-800 bg-opacity-50 rounded-full p-2 hover:bg-opacity-70 transition-all"
          onClick={onClose}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <div className="bg-white shadow-lg overflow-hidden max-h-[80vh] rounded-lg">
          <img 
            src={correctedImageUrl} 
            alt="Preview" 
            className="w-full h-auto max-h-[80vh] object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default ImagePreviewDialog; 